import { GetLease } from "../../../WorkSpace/Components/ApiServices/apiHandler";

export const fetchAllLease = (search = "") => {
    return dispatch => {
        dispatch({type:"LEASE_ACTION_START"})
        GetLease(search).then((result)=>{
            dispatch({
                type: "LEASE_FETCH_DATA",
                payload: result.data.projects
            }) 
        }).catch((error)=>{
            dispatch({
                type: "LEASE_FETCH_DATA_FAILED",
                payload: error.response.data.error
            }) 
        });
    }
}
